import dotenv from "dotenv";

dotenv.config();

// Initialize Realm app with your App ID
const app = new Realm.App({ id: `${process.env.REALM_WEB_ID}` });

// Function to register a new user with email and password
async function register(email, password) {
  await app.emailPasswordAuth
    .registerUser(
      {
        email: email,
        password: password,
      },
      { pending: true }
    )
    .then(() => {
      setSuccess("Patvirtinimo el. laiškas sėkmingai išsiųstas.");
      const submitButton = document.getElementById("auth");
      submitButton.textContent = "Registracija";
      submitButton.textContent = submitButton.textContent.toUpperCase();
      submitButton.disabled = false;
    })
    .catch(() => {
      const submitButton = document.getElementById("auth");
      submitButton.textContent = "registracija";
      submitButton.textContent = submitButton.textContent.toUpperCase();
      submitButton.disabled = false;
      setError("El. paštas jau egzistuoja.");
    });
}

function setError(errorMessage) {
  document.getElementById("allerts").classList = "errorAllerts";
  const error = document.createElement("div");
  error.classList.add("error-message");
  error.textContent = errorMessage;
  document.getElementById("allerts").appendChild(error);
}

function setSuccess(message) {
  clearErrors();
  const success = document.getElementById("allerts");
  success.classList.add("successAllerts");
  success.textContent = message;
}

function clearErrors() {
  const inputs = document.querySelectorAll("input");
  inputs.forEach((input) => {
    input.classList.remove("error");
  });

  const error = document.getElementById("allerts");
  error.removeAttribute("class");
  error.textContent = "";
}

// Function to handle form submission and register
export async function registerUsers() {
  const email = document.getElementById("email").value;
  const password = document.getElementById("password").value;
  await register(email, password);
}
